import type { Cart } from '@jane/bloom/viewModels/cart';

/**
 * A Jane Gold reward the API dropped because its campaign could not fund the whole thing.
 * Rewards are all or nothing, so the discount vanishes rather than shrinking, and the bag
 * quietly costs more unless we say so.
 */
export const BRAND_SPECIAL_BUDGET_EXHAUSTED = 'brand_special_budget_exhausted';

export const BRAND_SPECIAL_SHORTFALL_MESSAGE =
  "Your Jane Gold cash back reward isn't available and has been removed from your bag.";

export const hasBrandSpecialShortfall = (response: Cart): boolean =>
  response?.cart?.brand_special_unavailable_reason ===
  BRAND_SPECIAL_BUDGET_EXHAUSTED;
